import * as React from 'react';
// import InfoPopover from './components/InfoPopover';

interface IBenefit {
  title: string;
  coverLevel?: string;
  description: any;
  value: any;
}

class Benefit extends React.Component<IBenefit> {
  public render() {
    const { title, description } = this.props;

    const benefitValue = () => {
      const { title, value, coverLevel } = this.props;

      if (title === 'Winter sports') {
        return 'Optional';
      }

      if (title === 'Cruise cover' && coverLevel === 'platinum') {
        return 'Included as standard';
      }

      if (title === 'Cruise cover' && coverLevel !== 'platinum') {
        return 'Optional';
      }

      if ((title === 'Gadget cover' || title === 'Golf cover') && coverLevel !== 'admiral') {
        return 'Optional';
      }

      return value === 'n/a' || value === 'nil' ? 'x' : value;
    };

    return (
      <div>
        <div className="quote-section">
          <div className="benefits-title--mobile">{title}</div>
          {/*<InfoPopover*/}
          {/*description={description}*/}
          {/*/>*/}
          <h4 className="benefit-title">{benefitValue()}</h4>
        </div>
      </div>

    );
  }
}

export default Benefit;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/components/Benefit/index.tsx